export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";